<template>
  <div>
    <Breadcrumb :options="breadcrumb" />

    <Wxts :wxtsList="wxtsList" />

    <TabMenu :menuIndex="menuIndex" :menu="menu" />

    <div>
      <router-view></router-view>
    </div>
  </div>
</template>

<script>
import { mapState } from "vuex";

export default {
  props: [
    'idx',
    'status',
  ],
  data() {
    return {
      breadcrumb: [
        { name: "车辆管理", path: `/vehicle/hang` },
        { name: "挂车管理", path: `/vehicle/hang` },
      ],
      wxtsList: [
        {
          name: '该处添加的挂车，可在【车辆管理】',
          path: '/vehicle/manage',
          pathName: '【自有车辆】',
          tailName: '处绑定。',
        }
      ],
      menuIndex: '',
      menu: [],
      list: ['在用', '停用', '报废'],
    };
  },
  computed: {
    ...mapState([
      'store'
    ]),
  },
  methods: {
  },
  watch: {
    $route(to, from) {
      // console.log(from, to)
      if (to.params.idx !== from.params.idx) {
        this.menu = []
        this.list.map((v, i) => {
          const o = {
            name: v,
            path: `/vehicle/hang/table/${i + 1}`,
          }
          this.menu.push(o)
        })
      }
      this.$nextTick(() => {
        // console.log(this.menuIndex)
        this.menuIndex = this.$route.path
        // console.log(this.menuIndex)
        // console.log(this.menu)
      })
    },
  },
  mounted() {
    this.list.map((v, i) => {
      const o = {
        name: v,
        path: `/vehicle/hang/table/${i + 1}`,
      }
      this.menu.push(o)
    })
    this.menuIndex = this.$route.path
    // console.log(this.menuIndex)
    // console.log(this.menu)
  },
};
</script>

<style lang="less" scoped></style>
